// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"ca88f6ed","233":"b3672ac8","263":"74f5d785","282":"64eb4c13","368":"7af984fc","449":"eefbe3ce","462":"766ab267","512":"6fbf5f20","623":"15b06c3c"}[chunkId] + ".chunk.js";
};